import { Grid, IconButton, Stack, Typography } from '@mui/material';
import React from 'react';
import logo from '../../../../assets/images/logo-full.svg';
import launch from '../../../../assets/images/launch.png';
import handshake from '../../../../assets/images/handshakeBlue.png';
import contact from '../../../../assets/images/contactBlue.png';
import profile from '../../../../assets/images/profileBlue.png';
import bell from '../../../../assets/images/bellBlue.png';
import { useTheme } from '@emotion/react';
import QuickActionCard from './QuickActionCard';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { useTranslation } from 'react-i18next';

const quickActionData = [
  {
    id: 0,
    title: 'Trade Management',
    desc: `Let's explore our trade management system module`,
    icon: handshake,
  },
  {
    id: 1,
    title: 'Contact Management',
    desc: `Let's explore our trade management system module`,
    icon: contact,
  },
  {
    id: 2,
    title: 'User Management',
    desc: `Let's explore our trade management system module`,
    icon: handshake,
  },
];

const quickAccessData = [
  {
    id: 0,
    title: 'Profile Settings',
    desc: `Let's explore our trade management system module`,
    icon: profile,
  },
  {
    id: 1,
    title: 'Notification Settings',
    desc: `Let's explore our trade management system module`,
    icon: bell,
  },
];

export default function GettingStarted() {
  const navigate = useNavigate();
  const theme = useTheme();
  const text = theme.palette.primary.text;
  const textLight = theme.palette.primary.textLight;
  const { user } = useSelector((state) => state.auth);

  const {t} = useTranslation()

  const handleNavigate = (index) => {
    if (index === 0) {
      navigate('tradeManagement');
    }
    if (index === 1) {
      if (user?.type === 'trader') {
        navigate('clientManagement');
      } else {
        navigate('contactManagement');
      }
    }
    if (index === 2) {
      navigate('userManagement');
    }
  };
  return (
    <Stack
      flex={1}
      direction="row"
      className="m-[8px] rounded-[8px] bg-white overflow-auto"
    >
      <Stack flex={2} />
      <Stack className="mt-[16px]">
        <Stack
          direction={'row'}
          alignItems={'center'}
        >
          <img
            src={logo}
            width={'172px'}
          />
          <Stack className="ml-[16px]">
            {/* <Typography
              className="ff-Roboto fw-medium fs-24"
              color={'#00A632'}
            >
              Welcome
            </Typography> */}
            <Typography
              className="ff-Roboto fw-regular fs-14"
              color={'#14285AB3'}
            >
             {t('Welcome to Carbon Wallet platform. Hereʼs a quick guide to get you started and make the most out of your experience')}.
            </Typography>
          </Stack>
        </Stack>
        <Stack
          style={{ backgroundColor: '#FFFFCC', borderRadius: '8px', cursor: 'pointer' }}
          className="!px-[24px] !pt-[32px] !w-[100%] mt-[40px]"
          onClick={() => navigate('settings')}
        >
          <Stack
            direction={'row'}
            alignItems={'center'}
          >
            <img
              src={launch}
              width={'40px'}
              height={'40px'}
            />
            <Stack className="ml-[24px]">
              <Typography
                className="ff-Roboto fw-medium fs-16"
                color={text}
              >
                {user?.type === 'trader' ? t('Setup Your Company') : t('Setup your Organization')}
              </Typography>
              <Typography
                className="ff-Roboto fw-regular fs-12"
                color={text}
              >
                {user?.type === 'trader' ? t('Click here to setup your company profile') : 'Click here to setup your profile'}
              </Typography>
            </Stack>
          </Stack>

          <Stack alignSelf={'flex-end'}>
            <IconButton>
              <ArrowForwardIcon style={{ color: '#FFCC00' }} />
            </IconButton>
          </Stack>
        </Stack>
        <Stack className="mt-[40px] mb-[10px]">
          <Typography
            className="ff-Roboto fw-bold fs-16"
            color={'#003399'}
          >
            {t('Quick Actions')}
          </Typography>
        </Stack>
        <Stack
          direction={'row'}
          flexWrap={'wrap'}
          alignItems={'center'}
          justifyContent={'space-between'}
        >
          {quickActionData?.map((item, index) => (
            <QuickActionCard
              data={item}
              type={'action'}
              onClick={() => {
                handleNavigate(index);
              }}
            />
          ))}
        </Stack>
        <Stack className="mt-[40px] mb-[10px]">
          <Typography
            className="ff-Roboto fw-bold fs-16 "
            color={'#003399'}
          >
            {t('Quick Access')}
          </Typography>
        </Stack>
        <Stack
          direction={'row'}
          flexWrap={'wrap'}
          alignItems={'center'}
        >
          {quickAccessData?.map((item, index) => (
            <Stack className="mr-[27px]">
              <QuickActionCard
                data={item}
                type={'access'}
                onClick={() => {
                  index === 0 ? navigate('settings', { state: { index: 1 } }) : navigate('settings', { state: { index: 2 } });
                }}
              />
            </Stack>
          ))}
        </Stack>
      </Stack>
      <Stack flex={2} />
    </Stack>
  );
}
